const Constants = (function () {
  const userTypes = {
    thriver: "thriver",
    caregiver: "caregiver",
    careHome: "carehome",
  };

  const dashboardRoles = {
    caregiver: "careProviderAdmin",
    careHome: "careHomeAdmin",
    admin: "superAdmin",
    admin_2: "admin",
  };

  const userTableTypes = {
    careHomes: "carehomes",
    users: "users",
    caregivers: "caregivers",
  };

  const moods = {
    happy: "happy",
    normal: "normal",
    sad: "sad",
  };

  const LocationTypeConstant = {
    single: 'single',
    all: 'all',
    country: 'country'
  }
  const Support_Status_Constant = {
    'IN_PROGRESS': 'IN_PROGRESS',
    "RESOLVED": 'RESOLVED',
    'OPEN': 'OPEN',
    'REJECTED': 'REJECTED'
  }
  const Support_Status_Text = {
    IN_PROGRESS: "In Progress",
    RESOLVED: "Resolved",
    OPEN: "Open",
    REJECTED: "Rejected",
  };
  const filterValueConstant = {
    "last-7-days": "last-7-days",
    "last-30-days": "last-30-days",
  };
  
  const dashboardChartTypeConstant = {
    'bloodPressure'  : { label: 'Blood Pressure', value: 'bloodPressureAnalytics' },
    'heartRate'  : { label: 'Heart Rate', value: 'heartRateAnalytics' },
    'steps'  :{ label: 'Steps', value: 'stepsAnalytics' },
    'sleep'  : { label: 'Sleep', value: 'sleepAnalytics' },
  };
  const durationData = [
    {label : '30 Mins', value  :30 },
    {label : '45 Mins', value  :45 },
    {label : '60 Mins', value  :60 }
  ]
  const surveyType = {
    loneliness : 1,
    wellbeing : 2,
    PHQ9 : 3,
    GAD7 : 4,
    suicide : 5,
    safety : 6,
  }

  const renderLabelForSurveyLevel = {
    'level_1' : 'Low',
    'level_2' : 'Below Average',
    'level_3' : 'Average',
    'level_4' : 'High',
  }
  return {
    userTypes, dashboardRoles, userTableTypes, moods, LocationTypeConstant,
    Support_Status_Text, Support_Status_Constant ,filterValueConstant,dashboardChartTypeConstant ,durationData,surveyType, renderLabelForSurveyLevel
  };
})();

export default Constants;
